import { useEffect } from 'react'

function addOverflowHidden() {
  document.body.classList.add('overflowHidden')
  document.body.classList.remove('overflowUnset')
}

function resetOverflow() {
  document.body.classList.add('overflowUnset')
  document.body.classList.remove('overflowHidden')
}

const useLockBodyScroll = (freeze: boolean) => {
  useEffect(() => {
    if (freeze) {
      addOverflowHidden()
    } else {
      resetOverflow()
    }
  }, [freeze])

  useEffect(() => {
    return () => {
      resetOverflow()
    }
  }, [])
}

export default useLockBodyScroll
